module.exports = __webpack_public_path__ + "static/img/8_IMG_20160310_134138.2e757de4.jpg";